import React from 'react';
import styles from './StepDescription.module.scss';
import B18 from '../../../Common/Text/B18/B18';

function StepDescription({ children }: JSX.ElementChildrenAttribute) {
  return (
    <B18 centered className={styles.text}>
      {children}
    </B18>
  );
}

export default StepDescription;
